'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';

export default class RaceMap extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    markerPos: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props);
    this.map = null;
    this.waypoints = this.props.data;
  }

  setMarker() {
    const pos = this.props.markerPos;
    const posLatLng = [pos[0], pos[1]];
    return L.marker(posLatLng).addTo(this.map);
  }

  changeMarkerPosition(pos) {
    var latlng = [pos[0], pos[1]];
    this.marker.setLatLng(latlng);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const oldMarkerPos = this.props.markerPos;
    const newMarkerPos = nextProps.markerPos;
    if (oldMarkerPos[0] !== newMarkerPos[0] || oldMarkerPos[1] !== newMarkerPos[1]) {
      this.changeMarkerPosition(nextProps.markerPos);
      return true;
    }
    return false;
  }
  componentDidMount() {
    this.renderMap();
  }

  renderMap() {
    let random = Math.floor(Math.random() * 3);
    let balancer = ['a', 'b', 'c'];
    var maptilerLayer = L.tileLayer('https://api.maptiler.com/maps/outdoor-v2/{z}/{x}/{y}.png?key=28AMW2lB1Rs5IBe01O6r', {render: L.canvas()});
    var topoLayer = L.tileLayer('https://' + balancer[random] + '.tile.opentopomap.org/{z}/{x}/{y}.png', { renderer: L.canvas() });
    var bwLayer = L.tileLayer('https://api.maptiler.com/maps/ch-swisstopo-lbm-dark/{z}/{x}/{y}.png?key=28AMW2lB1Rs5IBe01O6r', { renderer: L.canvas() });
    var satelliteLayer = L.tileLayer('http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', { renderer: L.canvas() });
    var polyline = L.polyline(this.waypoints, { color: '#ffa301', weight: 3 })
    this.map = L.map(this.refs.map, {
      zoom: 10,
      layers: [maptilerLayer, polyline],
      preferCanvas: true
    }).setView([51.505, -0.09], 13);
    this.map.fitBounds(polyline.getBounds());
    var baseMaps = {
      "Outdoor": maptilerLayer,
      "OpenTopo": topoLayer,
      "B/W Layer": bwLayer,
      "Satellite": satelliteLayer
    };
    var overlayMaps = {
      "GPS Track": polyline
    };
    L.control.layers(baseMaps, overlayMaps).addTo(this.map);
    this.marker = this.setMarker();
  }

  render() {
    return (
      <div className="map-canvas">
        <div className="actual_map mb-4" ref="map" style={{height: '40vh'}} />
        {!this.map && <div className="center-md"></div>}
      </div>
    );
  }
}